/**
 * Brand — the sacred identity anchor.
 *
 * MeridianMark is the corner compass/meridian glyph: "fixed — never moves, collapses, or
 * changes across routes" (docs/design/MERIDIAN.md:1586, InstrumentBezel header). It is
 * identity, not a control, and never spins. Re-homed here verbatim from InstrumentBezel;
 * the geometry (graticule globe + filled compass-needle diamond) is unchanged.
 *
 * This is the one glyph that legitimately uses more than one stroke weight — the ring is
 * heavier than the faint graticule — so it composes Icon and sets stroke-width per path
 * rather than inheriting the single-weight default. It is the seed motif the rest of the
 * set rhymes with (lenses = graticule globes, pins = survey markers, the diamond = needle).
 */
import { Icon, type IconProps } from './Icon';

/** App identity / compass. Default lg (24) — matches the corner block. */
export const MeridianMark = (props: IconProps) => (
  <Icon size="lg" {...props}>
    <circle cx="12" cy="12" r="9" strokeWidth={1.6} />
    <path d="M12 3 L12 21 M3 12 L21 12" strokeWidth={1} opacity="0.5" />
    <path d="M12 5.5 L14.5 12 L12 18.5 L9.5 12 Z" fill="currentColor" stroke="none" />
  </Icon>
);
